module.exports = __webpack_public_path__ + "static/media/flags.723494a4.png";